import api from '../services/api.service';
import type { TAPIRequestShorthand } from '../types/api.type';

export const getAllData = async (
  options: TAPIRequestShorthand,
  method: 'get' | 'post' | 'patch' | 'put' | 'delete' = 'post'
) => {
  const totalValue = [];
  const { results, page, totalPages, limit } = await api[method](options);
  totalValue.push(...results);
  let lastPage = page;
  // Fetch the rest of the data in case there are more than 1 page
  for (let i = page + 1; i <= totalPages; i++) {
    const { results } = await api[method]({
      ...options,
      data: {
        ...(options?.data || {}),
        page: i,
      },
    });
    totalValue.push(...results);
    lastPage = i;
  }
  return {
    results: totalValue,
    totalPages,
    limit: limit,
    page: lastPage,
  };
};
